var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-modal", {
    attrs: { "model-value": _vm.show, size: "xl", scrollable: "" },
    on: {
      "update:model-value": function ($event) {
        return _vm.$emit("update:show", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "modal-header",
        fn: function () {
          return [
            _c("span", [
              _c("i", { staticClass: "far fa-list-alt text-primary mr-2" }),
              _vm._v("\n      Nilai\n    "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function () {
          return [
            _vm.url && _vm.extention == "pdf"
              ? _c("pdf", { attrs: { src: _vm.url } })
              : _vm.url && _vm.excelData.length
              ? _c(
                  "table",
                  { staticClass: "mt-4 border-collapse border w-full" },
                  [
                    _c("thead", [
                      _c(
                        "tr",
                        _vm._l(_vm.excelData[0], function (col, i) {
                          return _c(
                            "th",
                            {
                              key: "head-" + i,
                              staticClass: "border p-2 bg-gray-100",
                            },
                            [
                              _vm._v(
                                "\n            " + _vm._s(col) + "\n          "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.excelData.slice(1), function (row, r) {
                        return _c(
                          "tr",
                          { key: "row-" + r },
                          _vm._l(row, function (cell, c) {
                            return _c(
                              "td",
                              { key: "cell-" + c, staticClass: "border p-2" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(cell) +
                                    "\n          "
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      }),
                      0
                    ),
                  ]
                )
              : _c("div", { staticClass: "text-center" }, [
                  _vm._v("Gagal load file"),
                ]),
          ]
        },
        proxy: true,
      },
      {
        key: "modal-footer",
        fn: function () {
          return [
            _c(
              "b-button",
              {
                attrs: { type: "button", size: "sm", variant: "success" },
                on: {
                  click: function ($event) {
                    return _vm.download()
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa mr-1",
                  class:
                    _vm.extention === "pdf" ? "fa-file-pdf" : "fa-file-excel",
                }),
                _vm._v("\n      Download\n    "),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                attrs: { size: "sm", variant: "info" },
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-times mr-1" }),
                _vm._v("\n      Tutup\n    "),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }